import axios from 'axios'
import { API_BASE } from '../config'

// Sent when logged in, so the backend can tell whether a profile is the viewer's own
function authHeaders() {
    let token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export default class Profile {
    // GET /profile/of/:who - A player's public profile, by username or user id:
    // { id, username, bio, bioMaxLength, joined, isMine, cards: { ...statistics, rarest }, games: { spacejump: [record] } }
    get(who) {
        return axios.get(`${API_BASE}/profile/of/${encodeURIComponent(who)}`, authHeaders()).then(x => x.data);
    }

    // GET /profile/of/:who/cards - A player's whole card collection:
    // { id, username, isMine, collection, trimmed, mystic, packsOpened }
    getCards(who) {
        return axios.get(`${API_BASE}/profile/of/${encodeURIComponent(who)}/cards`, authHeaders()).then(x => x.data);
    }

    // GET /profile/me - The logged-in user's own profile
    getMine() {
        return axios.get(`${API_BASE}/profile/me`, authHeaders()).then(x => x.data);
    }

    // PUT /profile/bio - Set the logged-in user's biography: { success, bio }
    setBio(bio) {
        return axios.put(`${API_BASE}/profile/bio`, { bio }, authHeaders()).then(x => x.data);
    }

    // GET /profile/settings - The logged-in user's own account details:
    // { username, email, bio, hasPassword, bioMaxLength, usernameMinLength, usernameMaxLength }
    getSettings() {
        return axios.get(`${API_BASE}/profile/settings`, authHeaders()).then(x => x.data);
    }

    // PUT /profile/settings - Change any of { username, email, bio, newPassword }, with { currentPassword } when
    // changing the email or password; passwords are sent hashed, as when logging in. Resolves to the new settings;
    // a refusal's response names the field it is about: { field, message }
    saveSettings(changes) {
        return axios.put(`${API_BASE}/profile/settings`, changes, authHeaders()).then(x => x.data);
    }

    // DELETE /profile/account - Delete the logged-in user's own account for good. confirm is { currentPassword }
    // (hashed, as when logging in), or { username } for an account that only signs in with Google. A refusal's
    // response names the field it is about: { field, message }
    deleteAccount(confirm) {
        return axios.delete(`${API_BASE}/profile/account`, { ...authHeaders(), data: confirm }).then(x => x.data);
    }
}
